import React from "react"

//Utils
import Helmet from "react-helmet"
import Seo from "components/seo"

//Components
import Layout from "components/layout"
import HelpComp from "components/pages/help"
import LayoutGeneral from "components/layout-general-page"
import { getServerAuthenticated } from "lib/utils/get-sever-authentication"
import { TokenValidation } from "lib/function/token-validation"
import { F_Q_FAQ } from "lib/function"

const HelpPage = ({ ...props }) => {
  return (
    <>
      <Seo title="Help" />
      <Layout>
        <HelpComp {...props} />
      </Layout>
    </>
  )
}

export default HelpPage

//Server Side;
export const getStaticProps = async (ctx) => {
  let { locale, locales } = ctx
  const token = `${process.env.INIT_TOKEN}`
  // let { token, user_status } = await TokenValidation(ctx)
  let faqCat = await F_Q_FAQ({ lang: locale }, token, "all")
  let faqDesc = await F_Q_FAQ({ lang: locale }, token, "desc")

  if (faqCat.data && faqDesc.data) {
    return { props: { locale, token, faqCat, faqDesc }, revalidate: 60 }
  } else {
    return { notFound: true }
  }
}
